import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SetLeaveSession } from "../actions/sessionMethodActions";

export default function useRoomAgora({ setJoin }) {
  const [isRoomOpen, setIsRoomOpen] = useState(true);
  const [userLeave, setUserLeave] = useState(false);
  const storeRoomStatus = useSelector((state) => state.smvm_room_status);
  const storeUserLeave = useSelector((state) => state.smvm_user_leave);
  const dispatch = useDispatch();

  useEffect(() => {
    if (storeRoomStatus.success && storeRoomStatus.roomOpen == false) {
      setIsRoomOpen(false);
      setJoin(false);
      console.log("close room agora", false);
      // window.close();
    }
  }, [storeRoomStatus]);
  useEffect(() => {
    if (storeUserLeave.success && storeUserLeave.leave == true) {
      setUserLeave(true);
    }
  }, [storeUserLeave]);
  const handleLeaveAlone = (n) => {
    console.log("triger end leave", n);
    if (n == true) {
      dispatch(SetLeaveSession());
    }
  };
  return {
    isRoomOpen: isRoomOpen,
    userLeave,
    handleLeaveAlone,
  };
}
